// Wpisy z Instagrama: skrypt Instagrama (a z nim jego ciasteczka) dociągamy dopiero,
// gdy sekcja zbliża się do ekranu. Gdy się nie wczyta, w ramce zostaje link do wpisu.
const SRC = "https://www.instagram.com/embed.js";
let loading = null;

function loadEmbedScript() {
    loading ||= new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = SRC;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
    return loading;
}

export function initInstagram() {
    const blocks = [...document.querySelectorAll("[data-cc-instagram]")];
    if (!blocks.length) {
        return;
    }

    const start = (block) => loadEmbedScript()
        .then(() => {
            window.instgrm?.Embeds?.process();
            // ramki zmieniają wysokość po wczytaniu – animacje przy przewijaniu muszą się przeliczyć
            setTimeout(() => document.dispatchEvent(new CustomEvent("cc:layout")), 1200);
        })
        .catch(() => block.classList.add("is-offline"));

    if (!("IntersectionObserver" in window)) {
        blocks.forEach(start);
        return;
    }
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                start(entry.target);
            }
        });
    }, {rootMargin: "600px"});
    blocks.forEach((block) => observer.observe(block));
}
